<div class="page-type-nav">
   <carm-session-timeout></carm-session-timeout>
   <carm-deployment-timeout></carm-deployment-timeout>
  <!-- Header Content -->
  <carm-main-header-container></carm-main-header-container>

  <!-- Main Body -->
  <div class="context-wrapper content">
    <carm-main-body-container></carm-main-body-container>
    <carm-loader-spinner></carm-loader-spinner>
    <carm-loader-spinner-no-refresh></carm-loader-spinner-no-refresh>
  </div>

  <!-- Main Footer -->
  <carm-main-footer-container></carm-main-footer-container>
</div>
